import Vue from 'vue';
import VueRouter from 'vue-router';

import { getCurrentMenu } from '@/layout/base/components/inavbar/utils';
import BaseLayout from '@/layout/base/index.vue';
import Unauth from '@/layout/unauth/index.vue';
import { eventTrackManager } from '@/plugins/eventTrackManager';
import Account from '@/router/config/account';
import Application from '@/router/config/application';
import Checkout from '@/router/config/checkout';
import Collection from '@/router/config/collection';
import Content from '@/router/config/content';
import Developer from '@/router/config/developer';
import Fraud from '@/router/config/fraud';
import Report from '@/router/config/report';
import Risk from '@/router/config/risk';
import Settings from '@/router/config/settings';
import Settlement from '@/router/config/settlement';
import Subscription from '@/router/config/subscription';
import Summary from '@/router/config/summary';
import Transaction from '@/router/config/transaction';
import Transfer from '@/router/config/transfer';
import Wallet from '@/router/config/wallet';
import { getLocalStorage } from '@/utils/tools/utils';
import { getParentNode } from '@/views/account/permission/role/edit/index';
import { getApproveTaskByAssociationId } from '@/views/register/api/networkApplication/step-status';
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/user',
    name: 'UnAuth',
    component: Unauth,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/login/index.vue'),
      },
      {
        path: 'upgrade',
        name: 'Upgrade',
        component: () => import('@/views/login/upgrade.vue'),
      },
      {
        path: 'forget-password/auth',
        name: 'Forget Password Auth',
        component: () => import('@/views/forget-password/auth/index.vue'),
      },
      {
        path: 'forget-password/reset',
        name: 'Forget Password Reset',
        component: () => import('@/views/forget-password/reset/index.vue'),
      },
      {
        path: 'expire-password',
        name: 'Expire Password',
        component: () => import('@/views/account/password-expire/index.vue'),
      },
      {
        path: 'reset-password',
        name: 'Reset Password',
        component: () => import('@/views/account/password-reset/index.vue'),
      },
      {
        path: 'login/auth', // 运营端穿梭后的中间页
        name: 'Auth',
        component: () => import('@/views/login/auth.vue'),
      },
      {
        path: 'register', // 注册
        name: 'Register',
        component: () => import('@/views/register/index.vue'),
      },
      {
        path: 'register/done', // 注册完成
        name: 'Register Donw',
        component: () => import('@/views/register/done.vue'),
      },
      {
        path: 'acquiringMerchantRegister', // 收单商户注册
        name: 'acquiringMerchantRegister',
        component: () =>
          import('@/views/register/acquiringMerchantRegister/index.vue'),
      },
      {
        path: 'networkApplication', // 收单商户注册完成之后入网申请
        name: 'NetworkApplication',
        component: () =>
          import('@/views/register/networkApplication/index.vue'),
      },
      {
        path: 'networkApplication_old', // 新老注册页面存在的时候做判断展示
        name: 'NetworkApplicationOld',
        component: () =>
          import('@/views/register/networkApplication_old/index.vue'),
      },
    ],
  },
  {
    path: '/',
    name: 'Home',
    component: BaseLayout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import('@/views/index/index.vue'),
        meta: {
          icon: 'el-icon-s-home',
          showMerchantBar: true,
        },
      },
      {
        path: 'index/aggregate/:type',
        name: 'Index Aggregate',
        component: () => import('@/views/index/index_aggregate.vue'),
        meta: {
          icon: 'el-icon-s-home',
          showMerchantBar: true,
        },
      },
      ...Summary,
      ...Transaction,
      ...Settlement,
      ...Subscription,
      ...Account,
      ...Application,
      ...Content,
      ...Wallet,
      ...Collection,
      ...Transfer,
      ...Report,
      ...Risk,
      ...Checkout,
      ...Developer,
      ...Settings,
      ...Fraud,
      {
        path: '/demo',
        name: 'Demo',
        component: () => import('@/views/test/demo.vue'),
      },
      {
        path: 'cp-form-demo', // CP Form 组件演示
        name: 'CpFormDemo',
        component: () => import('@/views/cp-form-demo/index.vue'),
        meta: {
          title: 'CP Form 组件演示',
        },
      },
      {
        path: 'guide', // 引导页
        name: 'Guide',
        component: () => import('@/views/guide/index.vue'),
      },
    ],
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('@/views/error/index.vue'),
    children: [
      {
        path: '404',
        name: '404',
        component: () => import('@/views/error/404/index.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export function setupRouter(i18n, store) {
  // navigation guards
  router.beforeEach(async (to, from, next) => {
    console.log('guan2', to.path, store.getters.app.userLogin);
    document.body.scrollTop = 0;
    // const { currentLang } = store.state;
    if (!to.matched.length) {
      return next({
        path: '/error/404',
        replace: true,
      });
    }

    // 未登录
    if (to.path.indexOf('/user') !== 0 && !store.getters.app.userLogin) {
      return next({
        path: '/user/login',
      });
    }
    // 当路由为登录时，直接跳转
    if (to.path === '/user/login') {
      const host = window.location.host;
      const oldHostMap = store.getters.app.oldHostMap;
      const stopOldHostDate = store.getters.app.stopOldHostDate;
      const now = Date.now();
      if (now < stopOldHostDate && oldHostMap[host]) {
        return next({
          path: '/user/upgrade',
        });
      }
      return next();
    }
    // 跳转完善信息页,  当路由为穿越时，直接跳转,  当路由为注册时，直接跳转
    console.log('guan2', to.path, store.getters.app.userLogin);

    if (
      to.path === '/account/supplement' ||
      to.path === '/user/register' ||
      to.path === '/user/login/auth' ||
      to.path === '/user/networkApplication' ||
      to.path === '/user/networkApplication_old' ||
      to.path === '/user/acquiringMerchantRegister'
    ) {
      // const userLoginStr = getLocalStorage('userLogin');
      // if (!userLoginStr) {
      //   return next();
      // }

      // const userLogin = JSON.parse(userLoginStr);
      // const approveTask = await getApproveTaskByAssociationId(userLogin.userId);
      // // 根据templateCode判断应该跳转到哪个页面
      // if (to.path === '/user/networkApplication' || to.path === '/user/networkApplication_old') {
      //   if (approveTask.templateCode === '10' || !approveTask.templateCode) {
      //     if (to.path !== '/user/networkApplication') {
      //       return next({
      //         path: '/user/networkApplication',
      //       });
      //     }
      //   } else if (approveTask.templateCode === '06' || !approveTask.templateCode) {
      //     if (to.path !== '/user/networkApplication_old') {
      //       return next({
      //         path: '/user/networkApplication_old',
      //       });
      //     }
      //   }
      // }
      return next();
    }
    // if (to.path === '/index' && store.getters.app.userLogin.isAggregateMerchant) {
    //   if (store.getters.app.userLogin.businessTypes === 'ACQUIRING') {
    //     return next({
    //       path: '/index/aggregate/acq',
    //     });
    //   } else if (store.getters.app.userLogin.businessTypes === 'PAYOUT') {
    //     return next({
    //       path: '/index/aggregate/payout',
    //     });
    //   } else {
    //     console.log('guan出发');
    //     return next();
    //   }
    // }
    // console.log('guide', store.getters.app?.businessTypes);
    console.log('guide2', to);
    if ((to.params.type === 'payout') && !store.getters.app?.businessTypes?.pendingBusinessTypes && !store.getters.app?.businessTypes?.rejectedBusinessType && store.getters.app?.businessTypes?.businessTypes === 'ACQUIRING' && store.getters.app.userLogin.isAggregateMerchant && to.path !== '/guide') {
      return next({
        path: '/guide',
      });
    }

    if (
      !store.getters.app.userLogin.merchantNo &&
      store.getters.app.userLogin
    ) {
      return next({
        path: '/user/networkApplication',
      });
    }
    // 权限
    if (store.getters.app.userLogin) {
      await store.dispatch('permission/getMenus');
      const currentMenu = getCurrentMenu(store.getters.permission.menus, to);
      if (currentMenu) {
        // 页面子页面权限（菜单列表返回, 如权限管理）
        if (to.meta.permissionType && to.meta.permissionType === 'menu') {
          const submenus = [];
          for (let i = 0; i < currentMenu.childrenNode.length; i++) {
            submenus.push(currentMenu.childrenNode[i].resourceCode);
          }
          await store.dispatch('permission/setPages', {
            pageId: currentMenu.id,
            permission: submenus,
          });
        } else {
          // 页面按钮权限
          if (to.meta.parentPermissionType) {
            const pMenu = getParentNode(
              store.getters.permission.menus,
              currentMenu.parentId,
            );
            const submenus = [];
            for (let i = 0; i < pMenu.childrenNode.length; i++) {
              submenus.push(pMenu.childrenNode[i].resourceCode);
            }
            await store.dispatch('permission/setPages', {
              pageId: pMenu.id,
              permission: submenus,
            });
          }
          await store.dispatch('permission/getPages', currentMenu.id);
        }
      }
    }

    if (from.path !== '/' && from.path !== to.path) {
      eventTrackManager.send({
        e: 'exit_page',
      });
    }

    return next();
  });
  return router;
}
export default router;
